// Google Analytics 4 Event Tracking
export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, eventParams);
  }
};

export const trackViewFleet = () => {
  trackEvent('view_fleet');
};

export const trackViewCar = (carId: string) => {
  trackEvent(`view_car_${carId}`);
};

export const trackOpenDetails = (carId: string) => {
  trackEvent(`open_details_${carId}`);
};

export const trackOpenBooking = (carId: string) => {
  trackEvent(`open_booking_${carId}`);
};

export const trackSelectDays = (carId: string, days: number) => {
  trackEvent(`select_days_${carId}`, { days });
};

export const trackClickWhatsApp = (context: 'global' | string) => {
  if (context === 'global') {
    trackEvent('click_whatsapp_global');
  } else {
    trackEvent(`click_whatsapp_${context}`);
  }
};

export const trackQuickInquiry = (carId: string) => {
  trackEvent(`quick_inquiry_${carId}`);
};

export const trackDetailsInquiry = (carId: string) => {
  trackEvent(`details_inquiry_${carId}`);
};
